// extracted by mini-css-extract-plugin
export default {"app":"error-boundary_app__7f749","main":"error-boundary_main__cec4f"};